// extracted by mini-css-extract-plugin
export default {"detailGridWrap":"bankrec_detailGridWrap__zONG9","detailNestedGrid":"bankrec_detailNestedGrid__mlN8c"};